import clsx from "clsx";
import { fieldsTimeOutValue } from "components/Field/index";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { uniqueId } from "utils";

const LastNameField = ({
  lastName,
  setLastName,
  lastNameError,
  setLastNameError,
  labelText,
}) => {
  const id = uniqueId();

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (!initialLoad) {
        if (lastName === "") {
          setLastNameError(true);
        } else {
          setLastNameError(false);
        }
      }
    }, fieldsTimeOutValue);
    return () => clearTimeout(timeOutId);
  }, [lastName]);

  const handleChange = (e) => {
    setLastName(e.target.value);
    if (initialLoad) {
      setInitialLoad(false);
    }
  };

  return (
    <label
      htmlFor={`${id}_form_field-lastname`}
      className="form__field__lastname"
    >
      <b>{labelText || "Last Name"}</b>
      <input
        type="text"
        id={`${id}_form_field-lastname`}
        value={lastName}
        onChange={handleChange}
        className={clsx(lastNameError && "input__error")}
      />
    </label>
  );
};

export default LastNameField;

LastNameField.propTypes = {
  lastName: PropTypes.string.isRequired,
  setLastName: PropTypes.func.isRequired,
  lastNameError: PropTypes.bool.isRequired,
  setLastNameError: PropTypes.func.isRequired,
  labelText: PropTypes.string,
};
